module.exports = __webpack_public_path__ + "img/pn.a2911b5b.svg";